(function(angular){
    'use strict';

    class AccountEngagementWidget {
        constructor($window) {
            this.$window = $window;
        }

        gotoEmailEngagementHelp() {
            this.$window.open('https://help.meltwater.com/en/articles/4064606-how-to-improve-low-engagement-rates-for-releases');
        }
    }
    
    angular
        .module('MW.Influencers.AccountEngagementWidget', [])
        .component('mwAccountEngagementWidget', {
            bindings: {
                distributionCount: '<',
                openRate: '<',
                clickToOpenRate: '<',
                unsubscribedRate: '<'
            },
            controller: ['$window', AccountEngagementWidget],
            template: `
                <md-card>
                    <md-card-title>
                        <span translate>
                            mw-outreach-collection__engagement-widget-title
                        </span>
                        <md-icon class="mw-helpcenter" md-svg-icon="action:ic_info_24px" aria-label="info" ng-click="$ctrl.gotoEmailEngagementHelp()" hide-xs />
                    </md-card-title>
                    <md-card-content layout="row" layout-align="space-around">
                        <div class="stat-card" layout="column">
                            <span class="stat-value">
                                {{$ctrl.distributionCount}}
                            </span>
                            <span translate class="stat-label">
                                mw-outreach-collection__header-title
                            </span>
                        </div>
                        <span class="stat-divider"></span>
                        <div class="stat-card" layout="column">
                            <span class="stat-value">
                                {{$ctrl.openRate}}
                            </span>
                            <span translate class="stat-label">
                                mw-outreach-collection__engagement-widget-open-rate
                            </span>
                        </div>
                        <span class="stat-divider"></span>
                        <div class="stat-card" layout="column">
                            <span class="stat-value">
                                {{$ctrl.clickToOpenRate}}
                            </span>
                            <span translate class="stat-label">
                                mw-outreach-collection__engagement-widget-click-rate
                            </span>
                        </div>
                        <span class="stat-divider"></span>
                        <div class="stat-card" layout="column">
                            <span class="stat-value">
                                {{$ctrl.unsubscribedRate}}
                            </span>
                            <span translate class="stat-label">
                                mw-outreach-collection__engagement-widget-unsubscribe-rate
                            </span>
                        </div>
                    </md-card-content>
                </md-card>
            `
        });
})(angular);
